﻿//src/desktop/ui/mainpage.js
import global from '../../../../../shared/utils/global.js';
import { formatZuluTime } from '../../../../../shared/utils/timeformats.js';
import { fetchDriverUnits } from '../../../../auth/views/login/auth.api.js';
import { fetchTrucks } from '../../../unit-sensors/views/unitdiagrams/repeaters/units.api.js';
import { WebSocketService } from '../../../../../services/websocketservice.js';
import { displayMainUnitsGroupsList, openNewUnitGroupForm, openEditDeleteUnitsGroupForm, openAssignUnitsGroupForm } from '../groups/unitgroupsview.js';
import { getUnits, getTrailers, updateUnitMetrics } from '../handleunitdata.js';
import { removeDetailPanes } from './manageviews.js';
import { openUnitConfigForm } from '../unitdiagrams/repeaters/unitconfig.js';
import { displayDetailPanes, displayUnitsListTrailersOnly } from '../unitdiagrams/detailpage.js';
import { displayStatusSummary, createSubunitContainers, loadUnitStatusDiagram, loadUnitOnlyStatusDiagram, loadTrailerStatusDiagram } from './unitstatusesdiagrams.js';


import { hideLoading } from '../../../../../shared/components/modal.js';
const wsService = new WebSocketService();

function getMainPaneSensorUpdates(units) {
  wsService.removeListeners(); //Remove all event listeners
  wsService.disconnect(); //Ensure any previous connection is closed    

  wsService.connect('sensorUpdates');

  wsService.addEventListener('message', (event) => {
    const data = event.detail;
    console.log('Received message for dashboard:', data);
    // Handle dashboard-specific data
    displaySensorUpdatesMain(units, data);
  });

  window.addEventListener('unload', () => {
    wsService.disconnect();
  });
}

function displaySensorUpdatesMain(units, data) {

  let unit = units.find(u => u.imei === data.imei);

  if (!unit) {
    console.warn(`Unit with IMEI ${data.imei} not found.`);
    return;
  }

  unit = updateUnitMetrics(unit, data);
  displayStatusSummary(units || []);

  if (document.getElementById(`u${data.imei}pressure${data.wheelSensorUID}`)) {
    const pressure = parseFloat(data.currentPressure).toFixed(1);
    document.getElementById(`u${data.imei}pressure${data.wheelSensorUID}`).innerText = pressure;
    document.getElementById(`u${data.imei}pressure${data.wheelSensorUID}`).className = `sensorvaluesstatus ${(unit.wheelSensors.find(s => s.sensorId === data.wheelSensorUID) ||
      unit.spareSensors.find(s => s.sensorId === data.wheelSensorUID)).pressureLabelColour}`;
  }

  if (document.getElementById(`u${data.imei}temperature${data.wheelSensorUID}`)) {
    document.getElementById(`u${data.imei}temperature${data.wheelSensorUID}`).innerText = `${data.currentTemperature}`;
    document.getElementById(`u${data.imei}temperature${data.wheelSensorUID}`).className = `sensorvaluesstatus ${(unit.wheelSensors.find(s => s.sensorId === data.wheelSensorUID) ||
      unit.spareSensors.find(s => s.sensorId === data.wheelSensorUID)).temperatureLabelColour}`;
  }

  if (document.getElementById(`u${data.imei}voltage${data.wheelSensorUID}`)) {
    document.getElementById(`u${data.imei}voltage${data.wheelSensorUID}`).innerText = `${data.currentVoltage.toFixed(1)}`;
    document.getElementById(`u${data.imei}voltage${data.wheelSensorUID}`).className = `sensorvaluesstatus ${(unit.wheelSensors.find(s => s.sensorId === data.wheelSensorUID) ||
      unit.spareSensors.find(s => s.sensorId === data.wheelSensorUID)).voltageLabelColour}`;
  }

  if (document.getElementById('lastupdatedmain')) {
    document.getElementById('lastupdatedmain').innerText = `${formatZuluTime(data.payloadTS)}`;
  }
}

export const main = async () => {

  const splashContainer = document.getElementById('splashcontainer');
  if (splashContainer) splashContainer.style.display = 'none';

  global.showMainPage = true;

  const userRole = global.userRole;

  const selectedUnit = localStorage.getItem('selectedUnit');

  if (userRole != 'Driver') { //hide hierarchyContainer, hierarchyContainer for 'Driver' does not exist
    const hierarchyContainer = document.getElementById("customerhierarchycontainer");
    Array.from(hierarchyContainer.children).forEach(child => {
      child.style.display = 'none'; // Hide other divs
    });
    hierarchyContainer.style.display = 'none';
  }

  if (userRole === 'Driver' && selectedUnit) {
    if (selectedUnit) {
      global.showMainPage = false;
      global.selectedUnitId = selectedUnit;
    }
  }

  const units = await getUnits();
  let visibleUnits = units;

  const container = document.getElementById("container");
  if (container) container.style.display = 'block';

  const unitsContainer = document.getElementById("unitscontainer");
  if (unitsContainer) unitsContainer.style.display = 'block';

  if (userRole === 'Driver') {
    const driverUnits = await fetchDriverUnits(); // returns a list of unitIds, or full unit objects?

    // Assume fetchDriverUnits returns an array of unit IDs:
    const driverUnitIds = driverUnits.map(u => u.imeiNumber); // adjust as needed

    visibleUnits = units.filter(unit =>
      driverUnitIds.includes(unit.imei) // match by ID
    );
  }

  global.units = visibleUnits;
  displayMain(visibleUnits);

  if (global.mainIntervalId) {
    clearInterval(global.mainIntervalId);
  }

  global.mainIntervalId = setInterval(async () => {
    const updatedUnits = await getUnits();
    visibleUnits = updatedUnits;
    //let filteredUnits = updatedUnits;

    if (userRole === 'Driver') {
      const driverUnits = await fetchDriverUnits();
      const driverUnitIds = driverUnits.map(u => u.imeiNumber);
      visibleUnits = updatedUnits.filter(unit =>
        driverUnitIds.includes(unit.imei)
      );
    }

    global.units = visibleUnits;
    displayMain(visibleUnits);
  }, 300000); //5 minutes: 1 minute = 60,000 milliseconds; 30 minutes = 30 * 60000 = 1800000 milliseconds;  
};

export const displayMain = async (units) => {
  try {
    try {

      if (global.showMainPage) {
        getMainPaneSensorUpdates(units);
        displayStatusSummary(units || []);
        displayMainPane(units);

      } else {
        if (global.mainIntervalId) {
          clearInterval(global.mainIntervalId);
        }
        displayDetailPanes();
      }

      if (!global.unitsGroupsEventsRegistered) {
        global.unitsGroupsEventsRegistered = true;
        registerUnitListEvents();
        //registerUnitGroupEvents(units);
      }

    } catch (error) {
      console.log("mainpageJS: main - ERROR " + error + ")");
      console.error(error);
      return;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export function displayMainPane(units) {

  if (global.mainUnitsListSelected) {
    displayMainUnitsList(units);
  } else {
    displayMainUnitsGroupsList(units);
  }

  removeDetailPanes();
  document.getElementById('mainpane').style.display = 'block';
  document.getElementById('unitslistmain').style.display = 'block';
  switch (global.selectedMetric) {
    case 'PRESSURE':
      document.getElementById('rbtnPressure').checked = true;
      break;
    case 'TEMPERATURE':
      document.getElementById('rbtnTemperature').checked = true;
      break;
    case 'VOLTAGE':
      document.getElementById('rbtnVoltage').checked = true;
      break;
  }

  // const statusRadioButtons = document.getElementById('statusradiobtns');
  // statusRadioButtons.onclick = (e) => {

  //   if (global.mainUnitsListSelected)
  //     displayStatusSummary(units || []);
  //   else
  //     displayStatusSummary(global.selectedGroupUnits || []);

  //   e.stopImmediatePropagation();
  // };

  const statusMetricChecks = document.querySelectorAll('.metric-status-check');

  statusMetricChecks.forEach(check => {
    check.onchange = (e) => {
      e.stopImmediatePropagation();

      const selectedUnits = global.mainUnitsListSelected
        ? units
        : global.selectedGroupUnits || [];

      displayStatusSummary(selectedUnits);
      displayMainPane(selectedUnits);
    };
  });
}

function registerUnitListEvents() {

  const units = global.units;
  const unitsListButtonMain = document.getElementById('unitslistbuttonmain');
  unitsListButtonMain.onclick = (e) => {
    e.stopImmediatePropagation();

    global.mainUnitsListSelected = true;
    global.selectedUnitId = 0;
    global.selectedGroupId = 0;
    global.selectedGroupUnits = [];
    document.getElementById('rbtnTemperature').disabled = false;
    document.getElementById('rbtnVoltage').disabled = false;

    main();
  };

  const unitGroupsButtonMain = document.getElementById('unitgroupsbuttonmain');
  unitGroupsButtonMain.onclick = (e) => {
    e.stopImmediatePropagation();

    global.mainUnitsListSelected = false;
    global.selectedUnitId = 0;
    global.selectedGroupId = 0;
    global.selectedGroupUnits = [];

    document.getElementById('rbtnPressure').checked = true;
    global.selectedMetric = 'PRESSURE';

    document.getElementById('rbtnTemperature').disabled = true;
    document.getElementById('rbtnVoltage').disabled = true;

    main();
  };

  const unitsMenuMain = document.getElementById('unitsmenumain');
  unitsMenuMain.onclick = (e) => {
    if (e.target.tagName === 'LI') {
      switch (e.target.id) {
        case 'truckslistmainpage':
          displayTrucksList();
          break;
        case 'trailerslistmainpage':
          displayTrailersList(units);
          break;
        case 'configuretrailersmainpage':
          openUnitConfigForm(null, null, 'TRAILER', null);
          break;
      }
    }
  };

  const unitsListMenu = document.getElementById('unitslistmenu');
  unitsListMenu.onclick = (e) => {
    if (e.target.tagName === 'LI') {
      switch (e.target.id) {
        case 'truckslistdetailpage':
          //displayTrucksList(units)
          break;
        case 'trailerslistdetailpage':
          displayUnitsListTrailersOnly();
          break;
        case 'configuretrailersdetailpage':
          openUnitConfigForm(null, null, 'TRAILER', null);
          break;
      }
    }
  };

  const unitGroupsMenuMain = document.getElementById('unitgroupsmenumain');
  unitGroupsMenuMain.onclick = (e) => {
    if (e.target.tagName === 'LI') {
      switch (e.target.id) {
        case 'newunitsgroupmain':
          openNewUnitGroupForm();
          break;
        case 'editdeleteunitsgroupmain':
          openEditDeleteUnitsGroupForm(units);
          break;
        case 'assignunitsgroupmain':
          openAssignUnitsGroupForm(units);
          break;
      }
    }
    //e.stopImmediatePropagation();
  };

  const unitgroupsmenu = document.getElementById('unitgroupsmenu');
  unitgroupsmenu.onclick = (e) => {
    if (e.target.tagName === 'LI') {
      switch (e.target.id) {
        case 'newunitsgroup':
          openNewUnitGroupForm(units);
          break;
        case 'editdeleteunitsgroup':
          openEditDeleteUnitsGroupForm(units);
          break;
        case 'assignunitsgroup':
          openAssignUnitsGroupForm(units);
          break;
      }
    }
    //e.stopImmediatePropagation();
  };

  const unitslistbutton = document.getElementById('unitslistbutton');
  unitslistbutton.addEventListener('click', function clickHandler(e) {
    e.stopImmediatePropagation();
    global.showMainPage = true;
    global.mainUnitsListSelected = true;
    global.selectedUnitId = 0;
    global.selectedGroupId = 0;
    global.selectedGroupUnits = [];
    localStorage.removeItem('selectedUnit');
    main();
  });

  const unitGroupsButton = document.getElementById('unitgroupsbutton');
  unitGroupsButton.onclick = (e) => {
    e.stopImmediatePropagation();

    global.mainUnitsListSelected = false;
    global.selectedUnitId = 0;
    global.selectedGroupId = 0;
    global.selectedGroupUnits = [];

    document.getElementById('rbtnTemperature').disabled = true;
    document.getElementById('rbtnVoltage').disabled = true;

    document.getElementById('rbtnPressure').checked = true;
    global.selectedMetric = 'PRESSURE';
    main();
  };
}

const displayMainUnitsList = (units) => {
  try {
    let unitsListMain = document.getElementById('unitslistmain');
    while (unitsListMain.hasChildNodes()) {
      unitsListMain.removeChild(unitsListMain.lastChild);
    }

    let unitsListFragment = document.createDocumentFragment();
    let unitsListContainerDiv = createUnitsListContainer();
    unitsListFragment.appendChild(unitsListContainerDiv);

    unitsListMain.appendChild(unitsListFragment);

    for (let i = 0; i < units.length; i++) {

      let u = units[i];

      const isGroupUnit = false;
      const unitDiv = createMainUnitContainer(u, isGroupUnit);
      unitsListContainerDiv.appendChild(unitDiv);

      unitDiv.onclick = (e) => {
        e.stopImmediatePropagation();
        global.showMainPage = false;
        global.selectedUnit = u;
        global.selectedUnitId = u.unitId || u.imei;

        global.selectedGroupId = 0;
        global.sensorValuesDiagramDateSelected = false;
        global.selectedDateTime = "";
        displayDetailPanes();
      };
    }

    hideLoading();
    document.body.style.cursor = 'default';

  }
  catch (e) {
    console.error("mainpageJS - displayMainUnitsList: " + e.message);

    global.selectedUnitId = 0;
    return;
  }
};

async function displayTrucksList() {
  try {

    const units = await getUnits();
    const trucks = await fetchTrucks();
    const truckIds = new Set(trucks.map(t => t.Id));
    const trucksOnly = units.filter(unit =>
      unit.type === 'truck' && truckIds.has(unit.Id || unit.unitId)
    );

    let unitsListMain = document.getElementById('unitslistmain');
    while (unitsListMain.hasChildNodes()) {
      unitsListMain.removeChild(unitsListMain.lastChild);
    }

    let unitsListFragment = document.createDocumentFragment();
    let unitsListContainerDiv = createUnitsListContainer();
    unitsListFragment.appendChild(unitsListContainerDiv);

    unitsListMain.appendChild(unitsListFragment);

    //global.units = units;        

    for (let u = 0; u < trucksOnly.length; u++) {

      const unit = trucksOnly[u];

      const isGroupUnit = false;
      const unitDiv = createUnitsContainer(unit, isGroupUnit);
      unitsListContainerDiv.appendChild(unitDiv);

      unitDiv.onclick = (e) => {
        e.stopImmediatePropagation();
        global.showMainPage = false;
        global.selectedUnit = unit;
        global.selectedUnitId = unit.unitId;
        const userRole = global.userRole;
        if (userRole === 'Driver') localStorage.setItem('selectedUnit', unit.unitId);
        global.selectedGroupId = 0;
        global.sensorValuesDiagramDateSelected = false;
        global.selectedDateTime = "";

        displayDetailPanes(unit);
      };
    }

    displayStatusSummary(trucksOnly || []);

    hideLoading();
    document.body.style.cursor = 'default';
    //document.getElementById('splashcontainer').style.display = 'none';
  }
  catch (e) {
    console.error("mainpageJS - displayTrucksList: " + e.message);
    global.selectedUnitId = 0;
    return;
  }
}

export function createUnitsContainer(unit, isGroupUnit) {

  const unitDiv = document.createElement('div');
  unitDiv.id = isGroupUnit ? `maingroupunit${unit.unitId}` : `mainunit${unit.unitId}`;
  unitDiv.className = 'unit';

  // Create the unitContent div that will contain the unit header and status diagram
  const unitContent = document.createElement('div');
  unitContent.className = 'unit-content';

  // Create the unit header div
  const unitHeaderDiv = document.createElement('div');
  unitHeaderDiv.className = 'unitheader';
  unitHeaderDiv.textContent = unit.name || unit.imei; // Add unit name or IMEI

  unitContent.appendChild(unitHeaderDiv);

  // Create the unit status div
  const unitStatusDiv = document.createElement('div');
  unitStatusDiv.className = 'unitstatus';

  const unitStatusDiagramDiv = loadUnitOnlyStatusDiagram(unit);
  //unitStatusDiagramDiv.className = 'statusdiagram';

  unitStatusDiv.appendChild(unitStatusDiagramDiv);
  unitContent.appendChild(unitStatusDiv);

  // Finally, append the unit content to the unit div
  unitDiv.appendChild(unitContent);

  return unitDiv;
}

const displayTrailersList = async (units) => {
  try {

    let trailers = await getTrailers(units);

    let unitsListMain = document.getElementById('unitslistmain');
    while (unitsListMain.hasChildNodes()) {
      unitsListMain.removeChild(unitsListMain.lastChild);
    }

    let unitsListFragment = document.createDocumentFragment();
    let unitsListContainerDiv = createUnitsListContainer();
    unitsListFragment.appendChild(unitsListContainerDiv);

    unitsListMain.appendChild(unitsListFragment);

    for (let t = 0; t < trailers.length; t++) {

      let trailer = trailers[t];

      const isGroupUnit = false;
      const trailerDiv = createTrailerContainer(trailer, isGroupUnit);
      unitsListContainerDiv.appendChild(trailerDiv);

      trailerDiv.onclick = function (e) {
        e.stopImmediatePropagation();
        global.showMainPage = false;
        global.selectedUnit = trailer;
        global.selectedUnitId = trailer.imei;
        const userRole = global.userRole;
        if (userRole === 'Driver') localStorage.setItem('selectedUnit', trailer.imei);
        global.selectedGroupId = 0;
        global.sensorValuesDiagramDateSelected = false;
        global.selectedDateTime = "";
        displayDetailPanes(trailer);
      };
    }

    displayStatusSummary(trailers || []);

    hideLoading();
    document.body.style.cursor = 'default';

    const splashContainer = document.getElementById('splashcontainer');
    if (splashContainer) splashContainer.style.display = 'none';
  }
  catch (e) {
    console.error("mainpageJS - displayMainUnitsList: " + e.message);

    global.selectedUnitId = 0;
    return;
  }
};

// Functions to duplicate objects based on wheelId's last character
function findUnits(objectsArray) {
  const newArray = [];

  objectsArray.forEach(obj => {
    if (obj.wheelSensors && Array.isArray(obj.wheelSensors)) {
      // Find the unique last digits of all wheelIds
      const uniqueLastDigits = [...new Set(obj.wheelSensors
        .map(sensor => sensor.wheelId.slice(-1))
        .filter(digit => digit === '0'))];

      // For each unique last digit, create a new object
      uniqueLastDigits.forEach(lastDigit => {
        // Create a copy of the object
        const newObject = { ...obj };

        // Filter the wheelSensors based on the current last digit
        newObject.wheelSensors = obj.wheelSensors.filter(sensor => sensor.wheelId.endsWith(lastDigit));

        if ('spareSensors' in newObject) {
          delete newObject.spareSensors;
        };

        // Only add the new object if there are wheelSensors that match
        if (newObject.wheelSensors.length > 0) {
          newArray.push(newObject);
        }
      });
    } else {
      // If there are no wheelSensors, simply add the original object
      newArray.push(obj);
    }
  });

  return newArray;
}

export function createTrailerContainer(trailer, isGroupUnit) {

  const unitDiv = document.createElement('div');
  unitDiv.id = isGroupUnit ? `maingroupunit${trailer.Id}` : `mainunit${trailer.Id}`;
  unitDiv.className = 'unit';

  // Create the unitContent div that will contain the unit header and status diagram
  const unitContent = document.createElement('div');
  unitContent.className = 'trailer-content';


  // Create the unit header div
  const unitHeaderDiv = document.createElement('div');
  unitHeaderDiv.className = 'unitheader';
  unitHeaderDiv.textContent = trailer?.name || trailer?.wheelSensors?.[0]?.repeater?.trailerName || trailer?.Id; // Add unit name or IMEI

  unitContent.appendChild(unitHeaderDiv);

  if (trailer?.wheelSensors && trailer.wheelSensors.length > 0) {
    const unitStatusDiv = document.createElement('div');
    unitStatusDiv.className = 'trailerstatus';

    const unitStatusDiagramDiv = loadTrailerStatusDiagram(trailer); // Load diagram
    //unitStatusDiagramDiv.className = 'statusdiagram';

    unitStatusDiv.appendChild(unitStatusDiagramDiv);
    unitContent.appendChild(unitStatusDiv);
  }
  unitDiv.appendChild(unitContent);

  return unitDiv;
}

export function createMainUnitContainer(unit, isGroupUnit) {
  const unitDiv = document.createElement('div');
  unitDiv.id = isGroupUnit ? `maingroupunit${unit.unitId}` : `mainunit${unit.Id}`;
  unitDiv.className = 'unit';

  // Create the unitContent div that will contain the unit header and status diagram
  const unitContent = document.createElement('div');
  unitContent.className = 'unit-content';

  // Create the toggle button
  const toggleButton = document.createElement('button');
  toggleButton.className = 'toggle-button';
  toggleButton.textContent = '+';
  toggleButton.addEventListener('click', (e) => {
    e.stopPropagation();  // Prevents the unitDiv's onclick from firing
    toggleUnitView(unit, toggleButton, unitDiv);
  });

  // Create the unit header div
  const unitHeaderDiv = document.createElement('div');
  unitHeaderDiv.className = 'unitheader';
  unitHeaderDiv.textContent = unit.name || unit.imei; // Add unit name or IMEI

  // Append the toggle button and the unitHeader to the unitContent in the desired order
  unitContent.appendChild(toggleButton);
  unitContent.appendChild(unitHeaderDiv);

  // Create the unit status div
  const unitStatusDiv = document.createElement('div');
  unitStatusDiv.className = 'unitstatus';

  const unitStatusDiagramDiv = loadUnitStatusDiagram(unit);
  //unitStatusDiagramDiv.className = 'statusdiagram';

  unitStatusDiv.appendChild(unitStatusDiagramDiv);
  unitContent.appendChild(unitStatusDiv);

  // Finally, append the unit content to the unit div
  unitDiv.appendChild(unitContent);

  return unitDiv;
}

function toggleUnitView(unit, toggleButton, unitDiv) {
  const isExpanded = toggleButton.textContent === '-';

  if (isExpanded) {
    toggleButton.textContent = '+';
    const subunitContainer = document.getElementById(`subunitcontainer${unit.unitId}`);
    if (subunitContainer) {
      subunitContainer.style.display = 'none';  // Hide trailers
    }
  } else {
    toggleButton.innerHTML = '-';
    let subunitContainer = document.getElementById(`subunitcontainer${unit.unitId}`);

    // Create the subunit container if it doesn't exist
    if (!subunitContainer) {
      subunitContainer = document.createElement('div');
      subunitContainer.id = `subunitcontainer${unit.unitId}`;
      subunitContainer.className = 'subunit-container';

      // Generate subunits based on the sensor's wheel ID
      const subunits = createSubunitContainers(unit);
      subunitContainer.appendChild(subunits);

      unitDiv.appendChild(subunitContainer);
    } else {
      subunitContainer.style.display = 'block';  // Show subunits
    }
  }
}

const createUnitsListContainer = () => {

  let unitsListContainerDiv = document.createElement('div');
  unitsListContainerDiv.id = 'unitslistcontainer';
  unitsListContainerDiv.className = 'unitslistcontainer';
  if (!global.mainUnitsListSelected) {
    unitsListContainerDiv.classList.add('unitsgrouplistcontainer');
  }

  return unitsListContainerDiv;
}





